import React from "react";
import { Helmet } from "react-helmet";

export default function Live1() {
  return (
    <>
      <Helmet>
        <title>Live - Khanqah Imdadia Ashrafia</title>
      </Helmet>
      <div className="pageTitle">
        <h1 className="detailTitle">
          خانقاہ امدادیہ (سندھ بلوچ سوسائٹی) مہ مجلس کا آغاز ہو گیا ہے۔
        </h1>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-6 live-audio">
            <video controls autoplay name="media">
              <source
                src="http://live.khanqah.org:8050/live"
                type="audio/mpeg"
              />
            </video>
          </div>
        </div>
      </div>
    </>
  );
}
